import React, { Component } from "react";
import "./index.less";
import platform from "Pub/js/platform";
const { NCLoading } = platform.base;
export default class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = { show: true };
    }
    render() {
        const { error, style, config } = this.props;
        if(error) {throw new Error(error);}
        return (
            <div className="nc-workbench-loading" style={{ ...style }}>
                <NCLoading container={this} show={this.state.show} {...config}/>
            </div>
        );
    }
}
